import { Stack, Typography } from '@mui/material';
import React from 'react';
import mitlogo from '../../mit-logo-branco.png';

const MobileHeader = ({ title }) => (
  <Stack
    direction="row"
    sx={{
      alignContent: 'center',
      height: '30px',
      width: '100%',
    }}
  >
    <Stack gap="14px" width="100%" direction="row" alignItems="center">
      <img
        style={{
          height: '26px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        alt="Eclipse Cross"
        src={mitlogo}
      />
      <Typography
        sx={{
          alignContent: 'center',
          height: '40px',
          color: '#FFF',
          fontSize: '16px',
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: '700',
          lineHeight: '24px',
          flex: 1,
          paddingLeft: '16px',
          paddingTop: '5px',
        }}
      >
        {title}
      </Typography>
    </Stack>
  </Stack>
);

export default MobileHeader;
